module.exports = __webpack_public_path__ + "img/full-sphere.72af7dd0.svg";